module.exports = __webpack_public_path__ + "favicon-16x16.png?276a73100ddcee744deedaa8d4cee442";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/favicon-16x16.png
// module id = 186
// module chunks = 0